<template>
  <div style="height: 100%;">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {

    }
  },
  watch:{
    $route(to,from){
      let isMobile = window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 是否手机端
      // console.log(isMobile,'是否手机端')
      // if(!isMobile) {
      //   // if (to.path != '/web') {
      //   //   this.$router.push({path:'/web'})
      //   // }
      // }else{
      //   if (to.path == '/web') {
      //     this.$router.replace({path:'/'})
      //   }
      // }
    }
  },
  created () {
    console.log(process.env.NODE_ENV);
  },
  methods: {

  }
};
</script>
<style lang="less">
@import './assets/style/font/iconfont.css';
</style>